import styled from 'styled-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { Platform } from 'sofa-reborn-react';

export const BodyStyle = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ButtonStyle = styled.div<{
	selected: boolean;
	disabled: boolean;
	platform: Platform;
}>`
	display: flex;
	border: ${(props) =>
		props.selected
			? SkapaTheme.border.thickness.thick + 'px solid ' + SkapaTheme.color.semantic.informative
			: SkapaTheme.border.thickness.thick + 'px solid ' + SkapaTheme.color.border.light};
	border-radius: ${SkapaTheme.border.radius.radius4}px;
	height: ${(props) => (props.platform === 'kiosk' ? '80px' : '60px')};
	cursor: ${(props) => (props.disabled ? 'auto' : 'pointer')};
	opacity: ${(props) => (props.disabled ? '0.3' : '1')};
	padding: 0 ${SkapaTheme.spacing.space125}px;
	img {
		height: 100%;
	}
	:focus {
		outline: none;
	}
`;

export const SelectedTextStyle = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	width: 100%;
	margin: 0 ${SkapaTheme.spacing.space125}px;
`;

export const SelectedTextSignStyle = styled.div`
	display: inline-flex;
	flex-direction: column;
	flex-grow: 1;
	margin: 0 ${SkapaTheme.spacing.space50}px;
`;

export const SelectedPriceStyle = styled.div<{
	writeDirection: string;
}>`
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;

	[data-element-name='kompis-price-formatter'] {
		display: inline-flex;
	}
	.armrestPickerPriceContainer {
		display: flex;
		flex-direction: ${(props) => (props.writeDirection === 'rtl' ? 'row-reverse' : 'row')};
	}
`;

export const DisclaimerStyle = styled.div`
	display: flex;
	align-items: center;
	padding-top: ${SkapaTheme.spacing.space125}px;
	div {
		height: fit-content;
	}
`;

export const DisclaimerTextStyle = styled.div<{
	writeDirection: string;
}>`
	margin: ${(props) =>
		props.writeDirection === 'rtl'
			? '0 ' + SkapaTheme.spacing.space100 + 'px' + ' 0 0'
			: '0 0 0 ' + SkapaTheme.spacing.space100 + 'px'};
`;

export const IconStyle = styled.div`
	height: fit-content;
`;

export const SpacingStyle = styled.div`
	height: ${SkapaTheme.spacing.space125}px;
`;
